// Lead Eligibility filters (drives the list-builder filter panel)

import { createKeywordFilter, createRadioFilter } from './factories';
import type { FilterRegistry } from './types';

export const leadEligibilityFilters: FilterRegistry = {
	leadEligibilityKeywords: {
		...createKeywordFilter({
			label: 'Keywords',
			placeholder: 'Search by name or email...',
			objectTable: 'user',
			listKeys: ['lead_eligibility'],
			fulltextFields: ['firstName', 'lastName', 'email'],
		}),
		queryParamName: 'searchTerm',
	},

	leadEligibilityIsEligible: {
		...createRadioFilter({
			label: 'Distribution Eligible',
			options: [
				{ id: 'All', label: 'All' },
				{ id: 'Yes', label: 'Eligible' },
				{ id: 'No', label: 'Not eligible' },
			],
			defaultValue: { id: 'All', label: 'All' },
			objectTable: 'user',
			fieldName: 'isDistributionEligible',
			listKeys: ['lead_eligibility'],
			colorScheme: 'green',
		}),
		queryParamName: 'leadEligibilityIsEligible',
	},

	leadEligibilityIsLicensed: {
		...createRadioFilter({
			label: 'Licensed',
			options: [
				{ id: 'All', label: 'All' },
				{ id: 'Yes', label: 'Licensed' },
				{ id: 'No', label: 'Unlicensed' },
			],
			// Default to only showing licensed (active) users — matches SM1 behavior.
			defaultValue: { id: 'Yes', label: 'Licensed' },
			objectTable: 'user',
			fieldName: 'isActive',
			listKeys: ['lead_eligibility'],
			colorScheme: 'blue',
		}),
		queryParamName: 'leadEligibilityIsLicensed',
	},

	leadEligibilityRoles: {
		type: 'multi-select',
		label: 'Role',
		placeholder: 'Search roles...',
		colorScheme: 'purple',
		searchable: true,
		loadOnFocus: true,
		displayFields: {
			id: 'id' as keyof unknown,
			primary: 'label' as keyof unknown,
		},
		// Options come from the lead-eligibility endpoint so the list-builder
		// stays self-contained and doesn't depend on a shared roles service.
		apiEndpoint: '/users/lead-eligibility/filter-options/roles',
		queryParamName: 'leadEligibilityRoles',
		multiple: true,
		queryMapping: {
			objectTable: 'user',
			joinType: 'direct',
		},
		format: 'array',
		valueExtractor: {
			property: 'id',
		},
		listKeys: ['lead_eligibility'],
	},
};
